// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__5BmMm","date-txt":"AppointmentSummaryNote_date-txt__RJESI"};